import React from "react";

import { faAngleDown } from "@fortawesome/pro-solid-svg-icons/faAngleDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Badge from "antd/es/badge";
import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import { DataAttributesProps } from "@mapmycustomers/shared/types/dataAttributes";
import SavedFilter from "@mapmycustomers/shared/types/viewModel/SavedFilter";
import { Button, ButtonProps } from "@mapmycustomers/ui";

import styles from "./FilterButton.module.scss";

const messages = defineMessages({
  buttonText: {
    id: "filters.button",
    defaultMessage: "Filter",
    description: "Title of the filter button",
  },
});

const MAX_COUNT = 9;

interface Props extends DataAttributesProps {
  buttonProps?: ButtonProps;
  buttonText?: string;
  className?: string;
  disabled?: boolean;
  filterCount: number;
  onClick?: () => void;
  pressed?: boolean;
  selectedSavedFilter?: SavedFilter;
}

const FilterButton: React.FC<Props> = ({
  buttonProps,
  buttonText,
  className,
  dataAttributes,
  disabled,
  filterCount,
  onClick,
  pressed,
  selectedSavedFilter,
}) => {
  const intl = useIntl();

  return (
    <Button
      {...dataAttributes}
      className={cn({ [styles.pressed]: pressed }, className)}
      disabled={disabled}
      onClick={onClick}
      rightIcon={<FontAwesomeIcon icon={faAngleDown} />}
      type="text"
      {...buttonProps}
    >
      <span className={styles.content}>
        {selectedSavedFilter
          ? selectedSavedFilter.name
          : buttonText ?? intl.formatMessage(messages.buttonText)}{" "}
        {filterCount > 0 && (
          <Badge
            className={styles.filtersButtonCount}
            count={filterCount}
            overflowCount={MAX_COUNT}
            size="small"
          />
        )}
      </span>
    </Button>
  );
};

export default FilterButton;
